import {
  OrderBy,
  TradesTableQueryVariables,
  useTradesTableQueryLazyQuery,
} from 'generated/graphql';
import React, { FunctionComponent, useCallback } from 'react';
import { TradesTableContainer } from './trades-table-container';

type Props = {
  filters?: {
    tradeId?: number;
    tradeGroupId?: number;
  };
  orderBy: {
    column: string;
    direction: string;
  };
  onSort?: (column: string, direction: string) => void;
};

export const TradesTableRepository: FunctionComponent<Props> = ({
  filters,
  orderBy,
  onSort,
}) => {
  const getVariablesByBilikZone = (
    bilikZoneId: number | undefined,
  ): TradesTableQueryVariables => ({
    order_by: [{ name: OrderBy.Asc }],
    where: {
      id: {
        _eq: filters?.tradeId,
      },
      tradeGroups: {
        tradeGroupId: {
          _eq: filters?.tradeGroupId,
        },
      },
    },
    whereProView: {
      bilikZoneId: {
        _eq: bilikZoneId,
      },
      status: {
        _eq: 'published',
      },
    },
    whereProPresentation: {
      proPresentation: {
        proViews: {
          bilikZoneId: {
            _eq: bilikZoneId,
          },
          status: {
            _eq: 'published',
          },
        },
      },
    },
    whereTradeProView: {
      proView: {
        bilikZoneId: {
          _eq: bilikZoneId,
        },
        status: {
          _eq: 'published',
        },
      },
    },
  });

  const [tradeTableQuery, { data: data, loading }] =
    useTradesTableQueryLazyQuery();

  const [tradeTableBisQuery, { data: dataBis }] =
    useTradesTableQueryLazyQuery();

  const tradeBilikZoneId = localStorage.getItem('tradeBilikZoneId');

  const tradeBilikZoneIdBis = localStorage.getItem('tradeBilikZoneIdBis');

  const fetchTradeTableQuery = useCallback(async () => {
    if (tradeBilikZoneId !== undefined) {
      await tradeTableQuery({
        variables: getVariablesByBilikZone(
          tradeBilikZoneId ? Number(tradeBilikZoneId) : undefined,
        ),
      });
    }
  }, [filters, tradeBilikZoneId]);

  const fetchTradeTableBisQuery = useCallback(async () => {
    if (tradeBilikZoneIdBis !== undefined) {
      await tradeTableBisQuery({
        variables: getVariablesByBilikZone(
          tradeBilikZoneIdBis ? Number(tradeBilikZoneIdBis) : undefined,
        ),
      });
    }
  }, [filters, tradeBilikZoneIdBis]);

  return (
    <TradesTableContainer
      loading={loading}
      orderBy={orderBy}
      onSort={onSort}
      trades={data?.trade || []}
      tradesBis={dataBis?.trade || []}
      refetch={fetchTradeTableBisQuery}
      refetchBis={fetchTradeTableQuery}
    />
  );
};
